import React, { useState, useEffect, useMemo } from "react";
import Pagination from "../../Config/Pagination";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link, useNavigate } from "react-router-dom";
import "../../Config/search.css";
import "../../Config/loader.css";

import "jspdf-autotable";
import "../../Config/loading.css";

import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { Tabs, Badge } from "antd";
import { InboxOutlined, SendOutlined } from "@ant-design/icons";

export default function Notify() {
  const navigate = useNavigate();

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");

    if (!userDetails) {
      navigate("/");
      return;
    }

    setUserData(JSON.parse(userDetails));
  }, [navigate]);
  const [userData, setUserData] = useState({});
  const [leadsData, setLeadsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [receivedNotifications, setReceivedNotifications] = useState([]);
  const [sentNotifications, setSentNotifications] = useState([]);
  const [activeTab, setActiveTab] = useState("received");

  const fetchData = async (id) => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}notifications/GetNotifications?userid=${id}`,
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.Status) {
        setReceivedNotifications(data.ReceivedNotifications || []);
        setSentNotifications(data.SentNotifications || []);
      } else {
        setReceivedNotifications([]);
        setSentNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setReceivedNotifications([]);
      setSentNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userData?.staffid) {
      fetchData(userData.staffid);
    }
  }, [userData]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    // Format as dd-mm-yyyy
    return `${day}-${month}-${year}`;
  };

  const itemsPerPage = 12;

  const filteredItems = useMemo(() => {
    const results = leadsData.filter(
      (item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.phonenumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.source_name &&
          item.source_name.toLowerCase().includes(searchTerm.toLowerCase())),
    );

    setCurrentPage(1);

    return results;
  }, [leadsData, searchTerm]);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const notificationList =
    activeTab === "received" ? receivedNotifications : sentNotifications;

  const filteredNotifications = notificationList.filter((item) => {
    return item.description.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const todayNotifications = [];
  const yesterdayNotifications = [];
  const olderNotifications = [];

  filteredNotifications.forEach((item) => {
    const itemDate = new Date(item.date);
    itemDate.setHours(0, 0, 0, 0);

    if (itemDate.getTime() === today.getTime()) {
      todayNotifications.push(item);
    } else if (itemDate.getTime() === yesterday.getTime()) {
      yesterdayNotifications.push(item);
    } else {
      olderNotifications.push(item);
    }
  });

  const renderNotifications = (title, notifications) => {
    if (notifications.length === 0) return null;

    return (
      <>
        <h6 className="fw-bold text-secondary  mb-2">{title}</h6>

        {notifications.map((item) => {
          // const additionalData = JSON.parse(item.additional_data || "{}");
          const notificationIcon = getNotificationIcon(item.additional_data);
          return (
            <div className="card shadow-sm border-0 mb-2" key={item.id}>
              <div className="card-body p-2">
                <div className="d-flex">
                  <div className="me-3">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: 35,
                        height: 35,
                        backgroundColor: notificationIcon.bg,
                      }}
                    >
                      <i
                        className={notificationIcon.icon}
                        style={{ color: notificationIcon.color }}
                      ></i>
                    </div>
                  </div>

                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start">
                      <Link to={item.link}>
                        <div className="fw-semibold">{item.description}</div>
                      </Link>
                      {activeTab === "received" && item.isread === 0 && (
                        <span
                          className="bg-danger rounded-circle"
                          style={{
                            width: "10px",
                            height: "10px",
                            display: "inline-block",
                          }}
                        ></span>
                      )}
                    </div>

                    <div className="row mt-2">
                      <div className="col-6">
                        <div className="fw-semibold text-truncate">
                          <i className="fa-solid fa-user text-success me-2"></i>
                          <span className="text-muted me-1">
                            {activeTab === "received" ? "From:" : "To:"}
                          </span>
                          {activeTab === "received"
                            ? item.FromStaffName
                            : item.ToStaffName}
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="fw-semibold text-truncate">
                          <i className="fa-regular text-info fa-clock me-1"></i>
                          {new Date(item.date).toLocaleString([], {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  const items = [
    {
      key: "received",
      label: (
        <span>
          <i className="fa-solid fa-inbox me-2"></i>
          Received ({receivedNotifications.length})
        </span>
      ),
    },
    {
      key: "sent",
      label: (
        <span>
          <i className="fa-solid fa-paper-plane me-2"></i>
          Sent ({sentNotifications.length})
        </span>
      ),
    },
  ];

  const getNotificationIcon = (type) => {
    switch ((type || "").toLowerCase()) {
      case "lead":
        return {
          icon: "fa-solid fa-user-plus",
          bg: "#E8F5E9",
          color: "#2E7D32",
        };

      case "followup":
        return {
          icon: "fa-solid fa-calendar-check",
          bg: "#FFF8E1",
          color: "#F9A825",
        };

      case "customer":
        return {
          icon: "fa-solid fa-users",
          bg: "#E3F2FD",
          color: "#1565C0",
        };

      case "invoice":
        return {
          icon: "fa-solid fa-file-invoice-dollar",
          bg: "#EDE7F6",
          color: "#5E35B1",
        };

      case "payment":
        return {
          icon: "fa-solid fa-money-bill-wave",
          bg: "#E8F5E9",
          color: "#388E3C",
        };

      case "creditnotes":
      case "creditnote":
        return {
          icon: "fa-solid fa-file-circle-minus",
          bg: "#FCE4EC",
          color: "#C2185B",
        };

      default:
        return {
          icon: "fa-solid fa-bell",
          bg: "#E3F2FD",
          color: "#1976D2",
        };
    }
  };

  return (
    <Base>
      <style>
        {`
    .notification-tabs .ant-tabs-tab {
      color: #6c757d;
      font-weight: 500;
    }

    .notification-tabs .ant-tabs-tab:hover,
    .notification-tabs .ant-tabs-tab:hover .anticon {
      color: #1B2850;
    }

    .notification-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: #1B2850 !important;
      font-weight: 600;
    }

    .notification-tabs .ant-tabs-tab.ant-tabs-tab-active .anticon {
      color: #1B2850 !important;
    }

    .notification-tabs .ant-tabs-ink-bar {
      background: #1B2850 !important;
      height: 3px;
    }
  `}
      </style>
      <div className="">
        <div className="d-flex justify-content-between">
          <div className="page-title">
            <h4>Notifications</h4>
          </div>
          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <span
                  className="badge"
                  style={{
                    backgroundColor: "#E0F2FE",
                    color: "#0284C7",
                    cursor: "pointer",
                    padding: "8px 12px",
                  }}
                >
                  <i className="fa-solid fa-check-double me-1"></i>
                  Mark all read
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="d-flex border-bottom mb-3">
        <button
          className={`btn rounded-0 px-0 me-4 ${
            activeTab === "received"
              ? "text-primary border-bottom  fw-semibold"
              : "text-secondary"
          }`}
          onClick={() => setActiveTab("received")}
        >
          Received ({receivedNotifications.length})
        </button>

        <button
          className={`btn rounded-0 px-0 ${
            activeTab === "sent"
              ? "text-primary border-bottom  fw-semibold"
              : "text-secondary"
          }`}
          onClick={() => setActiveTab("sent")}
        >
          Sent ({sentNotifications.length})
        </button>
      </div> */}
      <div className="">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          size="small"
          animated
          className="notification-tabs"
        />
      </div>
      <div className="col-12 mb-3">
        <div className="input-group">
          <input
            type="text"
            name="search"
            placeholder="Search..."
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="input-group-text bg-primary" id="basic-addon1">
            <i className="fa-solid fa-magnifying-glass"></i>
          </span>
        </div>
      </div>

      <div className="card-container mb-5">
        {loading ? (
          <div className="containers m-auto">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        ) : (
          <>
            {filteredNotifications.length === 0 ? (
              <div className="text-center py-4 text-muted">
                No notifications found.
              </div>
            ) : (
              <>
                {renderNotifications("Today", todayNotifications)}
                {renderNotifications("Yesterday", yesterdayNotifications)}
                {renderNotifications("Older", olderNotifications)}
              </>
            )}
          </>
        )}

        <div className="">
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={filteredItems.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      </div>

      <Footer></Footer>
    </Base>
  );
}
